import ExceptionBase from './base.exception';
const BadParamsExceptionCode = 'BAD_PARAMS';
export class BadParamsException extends ExceptionBase {
    constructor(message = 'Bad Params') {
        super(message);
        this.code = BadParamsExceptionCode;
    }
}
export const isBadParamsException = (err) => (err.code === BadParamsExceptionCode);
